import { Sprite } from 'pixi.js';

export class FluffyCloud {
    constructor(startX, endX, lowY, highY, container, app, cloudInt){
        var cloudTextures = [
            "cloud-1",
            "cloud-2"
        ];

        this.cloud = new Sprite.from(cloudTextures[cloudInt || 0]);
        this.cloud.anchor.set(0.5);
        this.cloud.scale.set(2);
        this.speed = this.getRandomInRange(12000, 30000);

        this.cloud.y = this.getRandomInRange(highY, lowY);

        if (startX >= 0){
            this.cloud.x = startX + (this.cloud.width / 2);
        }
        else{
            this.cloud.x = startX - (this.cloud.width / 2);
        }
        var end = endX;
        if (endX < startX){
            end -= this.cloud.width / 2;
        }
        else{
            end += this.cloud.width / 2;
        }

        container.addChild(this.cloud);
        app.tween()
            .wait(this.getRandomInRange(0, 12) * 1000)
            .call(() => {
                app.tween(this.cloud, {loop: true})
                    .to({x: end}, this.speed);
            });
    }

    getRandomInRange(max, min) {
        return Math.random() * (max - min) + min;
    }
}
